// extracted by mini-css-extract-plugin
export default {"share":"share__2iE1usPoavwOysRxUAFfn6"};